/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { experienceSchema } from './experience-schema';
import { FocusArea, PracticeAreaEnum, SkillGroup } from "../enums";
export const experiencesTaxonomySchema: z.AnyZodObject = z.object({
  createdAt: z.string().datetime().nullish(),
  experience: z.lazy(() => experienceSchema).nullish(),
  experienceId: z.string().uuid().nullish(),
  focusArea: z.nativeEnum(FocusArea),
  id: z.string().uuid(),
  legalSkills: z.array(z.string()).nullish(),
  practiceArea: z.nativeEnum(PracticeAreaEnum),
  skillGroup: z.nativeEnum(SkillGroup).nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type ExperiencesTaxonomy = z.infer<typeof experiencesTaxonomySchema>;
